"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _GroupButton = _interopRequireDefault(require("./GroupButton"));

var _Button = _interopRequireDefault(require("./Button"));

var _utils = require("../utils");

var _getLinkIconUrl = _interopRequireDefault(require("./getLinkIconUrl"));

var _dxcFlex = _interopRequireDefault(require("dxc-flex"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CustomButton = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(CustomButton, _React$PureComponent);

  function CustomButton() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "onClick", function (menu) {
      var handleClick = _this.props.handleClick;
      handleClick && handleClick(menu);
    });

    _defineProperty(_assertThisInitialized(_this), "renderList", function (row, index) {
      var _this$props = _this.props,
          language = _this$props.language,
          style = _this$props.style,
          handleClick = _this$props.handleClick,
          MEDIA_DOMAIN = _this$props.MEDIA_DOMAIN,
          PUBLIC_DOMAIN = _this$props.PUBLIC_DOMAIN,
          urlSplicing = _this$props.urlSplicing,
          disableLocation = _this$props.disableLocation,
          ui = _this$props.ui;

      if (row.type === 0) {
        return /*#__PURE__*/_react["default"].createElement(_GroupButton["default"], {
          ui: ui,
          onClick: handleClick,
          style: style,
          data: row,
          key: index,
          language: language,
          MEDIA_DOMAIN: MEDIA_DOMAIN,
          PUBLIC_DOMAIN: PUBLIC_DOMAIN,
          urlSplicing: urlSplicing
        });
      }

      var temp = row.children[0];
      if (disableLocation && temp.code === 2) return null;
      var title = (0, _utils.getLinkTitle)(temp, language);
      var src = (0, _getLinkIconUrl["default"])(row, MEDIA_DOMAIN, PUBLIC_DOMAIN, urlSplicing);
      return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        ui: ui,
        title: title,
        data: temp,
        onClick: _this.onClick.bind(_assertThisInitialized(_this), temp),
        key: index,
        style: style,
        src: src
      });
    });

    return _this;
  }

  var _proto = CustomButton.prototype;

  _proto.render = function render() {
    var customButton = this.props.customButton;
    return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], null, customButton.slice(0, 4).map(this.renderList));
  };

  return CustomButton;
}(_react["default"].PureComponent);

var _default = CustomButton;
exports["default"] = _default;
module.exports = exports.default;